// This file was auto-generated by commondatabuilder.
// Please don't edit it.

import { t } from "@lingui/macro";
import { li18n } from '../frontend/lib/i18n-lingui';

export type USStateChoice = "AK"|"AL"|"AZ"|"AR"|"CA"|"CO"|"CT"|"DE"|"DC"|"FL"|"GA"|"HI"|"ID"|"IL"|"IN"|"IA"|"KS"|"KY"|"LA"|"ME"|"MD"|"MA"|"MI"|"MN"|"MS"|"MO"|"MT"|"NE"|"NV"|"NH"|"NJ"|"NM"|"NY"|"NC"|"ND"|"OH"|"OK"|"OR"|"PA"|"PR"|"RI"|"SC"|"SD"|"TN"|"TX"|"UT"|"VT"|"VA"|"WA"|"WV"|"WI"|"WY";

export const USStateChoices: USStateChoice[] = [
  "AK",
  "AL",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
];

const USStateChoiceSet: Set<String> = new Set(USStateChoices);

export function isUSStateChoice(choice: string): choice is USStateChoice {
  return USStateChoiceSet.has(choice);
}

export type USStateChoiceLabels = {
  [k in USStateChoice]: string;
};

export function getUSStateChoiceLabels(): USStateChoiceLabels {
  return {
    AK: li18n._(t`Alaska`),
    AL: li18n._(t`Alabama`),
    AZ: li18n._(t`Arizona`),
    AR: li18n._(t`Arkansas`),
    CA: li18n._(t`California`),
    CO: li18n._(t`Colorado`),
    CT: li18n._(t`Connecticut`),
    DE: li18n._(t`Delaware`),
    DC: li18n._(t`District of Columbia`),
    FL: li18n._(t`Florida`),
    GA: li18n._(t`Georgia`),
    HI: li18n._(t`Hawaii`),
    ID: li18n._(t`Idaho`),
    IL: li18n._(t`Illinois`),
    IN: li18n._(t`Indiana`),
    IA: li18n._(t`Iowa`),
    KS: li18n._(t`Kansas`),
    KY: li18n._(t`Kentucky`),
    LA: li18n._(t`Louisiana`),
    ME: li18n._(t`Maine`),
    MD: li18n._(t`Maryland`),
    MA: li18n._(t`Massachusetts`),
    MI: li18n._(t`Michigan`),
    MN: li18n._(t`Minnesota`),
    MS: li18n._(t`Mississippi`),
    MO: li18n._(t`Missouri`),
    MT: li18n._(t`Montana`),
    NE: li18n._(t`Nebraska`),
    NV: li18n._(t`Nevada`),
    NH: li18n._(t`New Hampshire`),
    NJ: li18n._(t`New Jersey`),
    NM: li18n._(t`New Mexico`),
    NY: li18n._(t`New York`),
    NC: li18n._(t`North Carolina`),
    ND: li18n._(t`North Dakota`),
    OH: li18n._(t`Ohio`),
    OK: li18n._(t`Oklahoma`),
    OR: li18n._(t`Oregon`),
    PA: li18n._(t`Pennsylvania`),
    PR: li18n._(t`Puerto Rico`),
    RI: li18n._(t`Rhode Island`),
    SC: li18n._(t`South Carolina`),
    SD: li18n._(t`South Dakota`),
    TN: li18n._(t`Tennessee`),
    TX: li18n._(t`Texas`),
    UT: li18n._(t`Utah`),
    VT: li18n._(t`Vermont`),
    VA: li18n._(t`Virginia`),
    WA: li18n._(t`Washington`),
    WV: li18n._(t`West Virginia`),
    WI: li18n._(t`Wisconsin`),
    WY: li18n._(t`Wyoming`),
  };
}
